export const getURLParams = (url: string): Record<string, string> => {
  const regexPattern = /[?&]?([^=]+)=([^&]*)/g;
  const queryString = url.replace(/.*\?/, '').replace(/\+/g, ' ');
  const params: Record<string, string> = {};
  let tokens: RegExpExecArray | null;

  // Loop over entire url
  while ((tokens = regexPattern.exec(queryString))) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
};
